(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-reviews-grid"] && !Shopify.designMode) return;
  try {
    
function setupReviewScroll() {
  document.querySelectorAll('.ap-review-grid .jdgm-videos-container').forEach((track) => {
    if (track.dataset.apScrollReady) return;
    track.dataset.apScrollReady = 'true';
    const root = track.closest('.ap-review-grid');
    const mobile = window.matchMedia('(max-width: 599px)');
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', root.querySelector('.jdgm-title')?.textContent.trim() || document.title);
    const updateFocus = () => { track.tabIndex = mobile.matches ? 0 : -1; };
    updateFocus();
    mobile.addEventListener('change', updateFocus);
    const wrapper = track.closest('.jdgm-cards-wrapper');
    ['touchstart', 'touchmove', 'touchend', 'pointerdown', 'pointermove', 'pointerup'].forEach((type) => {
      wrapper.addEventListener(type, (event) => {
        if (mobile.matches) event.stopPropagation();
      }, { capture: true, passive: true });
    });
    const carousel = root.querySelector('.jdgm-cards-carousel');
    const stopAuto = () => {
      if (carousel.hasAttribute('data-transition-speed')) carousel.removeAttribute('data-transition-speed');
    };
    stopAuto();
    new MutationObserver(stopAuto).observe(carousel, { attributes: true, attributeFilter: ['data-transition-speed'] });
  });
}
setupReviewScroll();
document.addEventListener('shopify:section:load', setupReviewScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-highlights-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.highlights-banner__block-link[href="/?sfae"]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const chat = document.querySelector('shopify-chat');
  if (!chat) return;
  event.preventDefault();
  if (typeof chat.show === 'function') chat.show();
  else chat.setAttribute('open', '');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
